import { useCallback } from "react";

import PropTypes from "prop-types";

import { StatusEnum } from "@/features/shared";
import { CustomAsyncAutocomplete } from "@/features/ui";

// Shared presentational product picker. The concrete ProductSelect (global) and
// OutletProductSelect (outlet-scoped) wrappers inject `client` to choose which
// product list is queried; everything else — labels, options, styling — is
// identical, so it lives here.
export const ProductSelectBase = ({
  client,
  requestConfig,
  value,
  onChange,
  disabled,
  productCategoryType = null,
  TextFieldProps,
  ...props
}) => {
  const fetchProducts = useCallback(
    async (searchValue, { page, size } = {}) => {
      const {
        data: { data },
      } = await client.get("products", {
        params: {
          page,
          size,
          keyword: searchValue,
          status: StatusEnum.ACTIVE,
          productCategoryType,
        },
        // Carries the outlet scope for OutletProductSelect
        // (headers: { "Outlet-Id": outletId }); undefined for the global variant.
        ...requestConfig,
      });
      return data;
    },
    [client, requestConfig, productCategoryType]
  );

  return (
    <CustomAsyncAutocomplete
      value={value}
      onChange={onChange}
      disabled={disabled}
      fetchOptions={fetchProducts}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      renderOption={(props, option) => {
        const { id, name, skuPrefix } = option;

        return (
          <li {...props} key={id}>
            <div>
              <div>{name}</div>
              <div style={{ fontSize: "0.75rem" }}>{skuPrefix}</div>
            </div>
          </li>
        );
      }}
      TextFieldProps={{
        label: "Produk",
        InputProps: {
          placeholder: "Cari nama/sku produk",
        },
        ...TextFieldProps,
      }}
      {...props}
    />
  );
};

ProductSelectBase.propTypes = {
  client: PropTypes.object.isRequired,
  requestConfig: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  productCategoryType: PropTypes.string,
  TextFieldProps: PropTypes.object,
};
